---
meta:
  - title: Compartir exámenes - IUSPRO Docs
  - description: Aprende a compartir exámenes de práctica con otras personas.
---

# Compartir exámenes

Puede compartir sus exámenes de práctica con colegas o compañeros para que ellos también puedan practicar. Cada persona llena su propio examen de forma independiente, aunque las preguntas y respuestas correctas son las mismas para todos.

## Formas de compartir

Hay dos formas de compartir un examen:

### 1. Enlace público

Active la opción **Habilitar enlace público** y cualquier persona que tenga el enlace podrá acceder al examen.

- Haga clic en **Copiar enlace** para copiarlo al portapapeles
- Compártalo por WhatsApp, correo, o cualquier medio

### 2. Invitar por correo electrónico

Escriba el correo electrónico de la persona y haga clic en **Invitar**. El sistema le enviará un correo con un enlace directo al examen.

Puede invitar a varias personas. La lista de personas invitadas aparece debajo del campo de correo y puede eliminar a cualquiera en cualquier momento.

## ¿Dónde se comparte?

Puede acceder a las opciones de compartir desde:

- El **botón de compartir** en la página de detalle del examen
- El **menú de acciones** en la lista de exámenes

## ¿Qué pasa cuando alguien recibe un examen compartido?

Depende del estado de la persona que lo recibe:

- **Si tiene cuenta y suscripción activa**: Puede ver y tomar el examen directamente
- **Si tiene cuenta pero no suscripción**: Verá una vista previa del examen con el contenido difuminado y un mensaje para suscribirse
- **Si no tiene cuenta**: Verá una página invitándolo a crear una cuenta

## Exámenes compartidos conmigo

Los exámenes que otras personas han compartido con usted aparecen en la pestaña **Compartidos conmigo** dentro de la sección de Exámenes.

Desde ahí puede:

- Ver el detalle del examen
- Tomarlo para practicar
- **Re-compartirlo** con otras personas

## Cada quien tiene sus propios resultados

Cuando un examen se comparte, no se crea una copia. Todos trabajan sobre el mismo examen, pero cada estudiante tiene sus propias respuestas y resultados independientes. Esto significa que si usted toma el examen, sus respuestas no afectan las de nadie más.
